module.exports = __webpack_public_path__ + "static/img/gh_6b0dc94e5182_860.2f5e5c67.jpg";